import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';
import { LinkedUsersForGroupList } from '../model/LinkedUsersForGroupList/LinkedUsersForGroupList';
import { QmaConstant } from "../constant/qma-constant";

const httpFormPostOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};
@Injectable({
  providedIn: 'root'
})
export class AdvSearchService {
  public advSearchFormData: any = {
    content: '',
    subject: '',
    originator: '',
    from: '',
    to: '',
    cc: '',
    deliveredTo: '',
    mailingList: '',
    filename: '',
    rfc822msgId: '',
    sizeComparator: '',
    sizeValue: null,
    sizeUnit: 'MB',
    hasInlineImages: false,
    tag: '',
    clientCategory: '',
    status: '',
    searchInSnoozed: false,
    startDt: '',
    endDt: '',
    // p-inputSwitch binds to a boolean; keep this as boolean to avoid type instability.
    attachment: false,
    /** Enhanced Search In scope: ALL | Inbox | Pending Approval | Resolved | Sent */
    searchInScope: 'ALL'
  };
  baseURL: string;
  linkedUsersForGroupList: LinkedUsersForGroupList[];
  
  constructor(private httpClient: HttpClient) {
    this.baseURL = QmaConstant.BASE_URL + '/group';
  }
  
  getAdvSearchDetails(requestObj): Observable<LinkedUsersForGroupList[]> {
    return this.httpClient.post<LinkedUsersForGroupList[]>(this.baseURL + '/getLinkedUsersForGroupList', requestObj, httpFormPostOptions);
  }
}
